import { ChangeDetectorRef, DestroyRef, EventEmitter, inject } from '@angular/core';
import { ModelFormServiceFactory } from '@common/forms/frontend-shared';
import { UsernameAvailabilityRequest } from '@common/users/shared';
import { AppMessageFactory, AppRequestService, LocalMessageHandlerService } from '@core/frontend-shared';
import { ClientAppPlatform, ConfigService } from '@core/shared/config';
import { of, switchMap, throwError } from 'rxjs';
import { MembershipDisplayMode } from '../../state';
import * as i0 from "@angular/core";
import * as i1 from "@common/forms/frontend-shared";
import * as i2 from "@core/frontend-shared";
import * as i3 from "@core/shared/config";
export let MembershipRegistrationPluginFormComponent = /*#__PURE__*/(() => {
  class MembershipRegistrationPluginFormComponent {
    constructor(formServiceFactory, api, messages, cd, config, messageHandler) {
      this.formServiceFactory = formServiceFactory;
      this.api = api;
      this.messages = messages;
      this.cd = cd;
      this.config = config;
      this.messageHandler = messageHandler;
      this.destroyRef = inject(DestroyRef);
      this.onComplete = new EventEmitter();
      this.onSaveFormState = new EventEmitter();
    }
    ngOnInit() {
      this.formService = this.formServiceFactory.useDestroyRef(this.destroyRef).createModelForm(this.getFormModel());
      this.formService.setEditorDefinition(this.getEditorDefinition());
      this.formService.setSaveHandler({
        returnsUpdatedFormData: false,
        execute: data => {
          return this.executeSubmit(data);
        }
      });
      if (this.formData) this.formService.setInitialValue(this.formData);
      this.formService.initialize();
      this.instructions = this.getInstructions();
      const info = this.plugin.getStaticPluginInfo();
      this.pluginTitle = info.description || info.name;
    }
    getEditorDefinition() {
      return 'default';
    }
    patchFormValue() {
      if (this.formData) this.formService.setValue(this.formData);
    }
    // if observable resolves to true this indicates form is complete and parent can continue navigation
    executeSubmit(data) {
      return this.validateForm(data).pipe(switchMap(validationResult => {
        if (validationResult === true) {
          this.onComplete.emit(data);
          return of(true);
        } else {
          return throwError(() => validationResult);
        }
      }));
    }
    validateForm(data) {
      if (!this.requireAccountData) {
        return of(true);
      } else {
        const usernameIsEmail = this.config.get('users.usernameIsEmail', false);
        // both fields are possible right now because data is not a UserItem
        const userName = data.username || data.email;
        return this.api.sendRequest(UsernameAvailabilityRequest, {
          names: [userName]
        }).pipe(switchMap(response => {
          const isAvailable = response.free.length > 0;
          if (isAvailable) {
            return of(true);
          } else {
            const message = this.messages.create().setSeverity('warn').setSummary('Ein Account mit ' + (usernameIsEmail ? 'dieser E-Mail-Adresse' : 'diesem Benutzernamen') + ' existiert bereits!').setMessage('Wenn Sie bereits einen Account haben, loggen Sie sich bitte zuerst in diesen ein oder nutzen Sie die Passwort-zurücksetzen-Funktion.');
            this.messageHandler.add(message);
            return of(message);
          }
        }));
      }
    }
    onReset() {
      this.formService.resetForm({
        value: {}
      });
      this.cd.markForCheck();
    }
    getRegistrationFieldTitle(fieldId) {
      return this.plugin.getLabelForField(fieldId);
    }
    static {
      this.ɵfac = function MembershipRegistrationPluginFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipRegistrationPluginFormComponent)(i0.ɵɵdirectiveInject(i1.ModelFormServiceFactory), i0.ɵɵdirectiveInject(i2.AppRequestService), i0.ɵɵdirectiveInject(i2.AppMessageFactory), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.ConfigService), i0.ɵɵdirectiveInject(i2.LocalMessageHandlerService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MembershipRegistrationPluginFormComponent,
        selectors: [["ng-component"]],
        inputs: {
          plugin: "plugin",
          requireAccountData: "requireAccountData",
          submitsImmediately: "submitsImmediately",
          state: "state",
          displayMode: "displayMode",
          platform: "platform",
          formData: "formData"
        },
        outputs: {
          onComplete: "onComplete",
          onSaveFormState: "onSaveFormState"
        },
        decls: 0,
        vars: 0,
        template: function MembershipRegistrationPluginFormComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return MembershipRegistrationPluginFormComponent;
})();